import demo from './demoReducer';
import know from './knowReducer';
import session from './sessionReducer';
import app from './appReducer';
import expr from './expReducer';

const redux = {
  demo,
  know,
  session,
  app,
  expr,
};
export default redux;
